import { PersianDataPicker } from "components/form";
import { TextField } from "components/form";
import { Field, FieldArray } from "formik";

export default function AchievementComponent({ values, setFieldValue, type }) {
  return (
    <div className="w-full mt-20">
      <FieldArray name="achievements">
        {({ push: addAchievement, remove: removeAchievement }) => (
          <div>
            <div className="flex items-center justify-between mb-6">
              <h4 className="font-bold text-lg mb-4">دستاوردها</h4>
              <button
                type="button"
                onClick={() => {
                  addAchievement({
                    date: "",
                    entityType: type,
                    entity: values?.id,
                    translations: {
                      fa: {
                        title: "",
                        description: "",
                      },
                      en: {
                        title: "",
                        description: "",
                      },
                    },
                  });
                }}
                className="mb-4 px-4 py-2 bg-green-500 text-white rounded shadow hover:bg-green-600"
              >
                افزودن دستاورد
              </button>
            </div>

            {values.achievements?.map((achievement, idx) => (
              <div key={idx} className="mb-6 border p-4 rounded shadow">
                <div className="mb-4">
                  <div className="intro-x grid md:grid-cols-2 md:gap-3">
                    <Field
                      placeholder="عنوان"
                      label="عنوان :"
                      name={`achievements[${idx}]translations.fa.title`}
                      component={TextField}
                    />

                    <Field
                      placeholder="عنوان(en)"
                      label="عنوان(en) :"
                      name={`achievements[${idx}]translations.en.title`}
                      component={TextField}
                    />
                  </div>
                  <div className="intro-x grid md:grid-cols-2 md:gap-3">
                    <Field
                      placeholder="توضیحات"
                      label="توضیحات :"
                      name={`achievements[${idx}]translations.fa.description`}
                      component={TextField}
                    />

                    <Field
                      placeholder="توضیحات(en)"
                      label="توضیحات(en) :"
                      name={`achievements[${idx}]translations.en.description`}
                      component={TextField}
                    />
                  </div>
                </div>

                <div className="mb-4">
                  <label className="block text-gray-700 text-sm font-bold mb-2">
                    تاریخ دستاورد:
                  </label>
                  <Field
                    name={`achievements[${idx}].date`}
                    component={PersianDataPicker}
                    className="w-full px-3 py-2 border rounded shadow focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>

                <button
                  type="button"
                  onClick={() => {
                    setFieldValue("deleteAchievements", [
                      ...(values?.deleteAchievements || []),
                      values?.achievements[idx]?.id,
                    ]);
                    removeAchievement(idx);
                  }}
                  className="px-3 py-2 bg-red-500 text-white rounded shadow hover:bg-red-600"
                >
                  حذف دستاورد
                </button>
              </div>
            ))}
          </div>
        )}
      </FieldArray>
    </div>
  );
}
